import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from 'primevue/button';

import { useLogout } from '../composables/useLogout';


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutButton',
  setup(__props) {

const { logout, isPending } = useLogout();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    class: "w-full !justify-start",
    severity: "secondary",
    text: "",
    disabled: _unref(isPending),
    onClick: _unref(logout)
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("i", { class: "pi pi-sign-out" }, null, -1),
      _createTextVNode(" Wyloguj ")
    ])),
    _: 1
  }, 8, ["disabled", "onClick"]))
}
}

})